import store from "@/store/";

export default function(canvas) {
  const oldCanvasHeight = Math.round(canvas.height / canvas.getZoom());
  const oldCanvasWidth = Math.round(canvas.width / canvas.getZoom());
  let canvasWidth = 2480;
  let canvasHeight = 1200;
  let startPointY = 0;
  let startPointX = 0;
  let highest = Infinity;
  let leftest = Infinity;
  let lowest = 0;
  let rightest = 0;
  if (oldCanvasHeight === canvasHeight && oldCanvasWidth === canvasWidth)
    return;
  // ? calculate the heighest and the lowest items and calculatate their vertical position on canvas of text format
  for (let o of canvas._objects) {
    if (o.type === "textbox") {
      const minWidth = Math.max(...o.__lineWidths);
      let intendLeft = 0;
      if (o.textAlign === "center") intendLeft = (o.width - minWidth) / 2;
      if (o.textAlign === "right") intendLeft = o.width - minWidth;
      o.set({
        width: minWidth + 1,
        left: o.left + intendLeft * o.scaleX
      });
      canvas.renderAll();
    }
    if (o.top < highest) {
      highest = o.top;
    }
    if (o.top + o.height * o.scaleY > lowest) {
      lowest = o.top + o.height * o.scaleY;
    }
    if (o.left < leftest) {
      leftest = o.left;
    }
    if (o.left + o.width * o.scaleX > rightest) {
      rightest = o.left + o.width * o.scaleX;
    }
  }
  const allItemsHeight = lowest - highest;
  const allItemsWidth = rightest - leftest;
  const widthKf = (100 / canvasWidth) * allItemsWidth;
  const heightKf = (100 / canvasHeight) * allItemsHeight;
  let kf = 1;
  if (widthKf < 80 && heightKf < 80) {
    if (widthKf > heightKf) {
      kf = (1 / widthKf) * 80;
    } else {
      kf = (1 / heightKf) * 80;
    }
  }
  kf = kf < 1 ? 1 : kf;
  canvasWidth /= kf;
  canvasHeight /= kf;

  if (allItemsHeight < canvasHeight)
    startPointY = (canvasHeight - allItemsHeight) / 2;

  const differentHeight = highest - startPointY;

  if (allItemsWidth < canvasWidth)
    startPointX = (canvasWidth - allItemsWidth) / 2;

  const differentWidth = leftest - startPointX;

  for (let o of canvas._objects) {
    o.set({
      top: o.top - differentHeight,
      left: o.left - differentWidth
    });
    o.setCoords();
  }
  canvas.renderAll();
  // ? set canvas sizes of text format
  store.commit("workSpace/updateCanvasSizes", {
    width: canvasWidth,
    height: canvasHeight
  });
  canvas.renderAll();
  return {
    height: oldCanvasHeight,
    width: oldCanvasWidth
  };
}
